import lazyframe from "lazyframe";

function pauseYoutubeVideo(obj) {
    let command = {
        "event": "command",
        "func": "pauseVideo"
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}

function playYoutubeVideo(obj) {
    let command = {
        "event": "command",
        "func": "playVideo"
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}
function pauseVimeoVideo(obj) {
    let command = {
        "method": "pause",
        "value": 1
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}

function playVimeoVideo(obj) {
    let command = {
        "method": "play",
        "value" : 1
    };
    obj.contentWindow.postMessage(JSON.stringify(command), '*');
}
export function pauseSliderVideos (slider) {
    let slides = slider.el.querySelectorAll('.swiper-slide');
    for (let s in slides) {
        if(isNaN(s)) continue;
        if(slides[s].querySelector('video') !== null) slides[s].querySelector('video').pause();
        else if(slides[s].querySelector('iframe.yt-player') !== null) pauseYoutubeVideo(slides[s].querySelector('iframe.yt-player'));
        else if(slides[s].querySelector('iframe.vi-player') !== null) pauseVimeoVideo(slides[s].querySelector('iframe.vi-player'));
    }
}

export function playSliderVideos(slider) {
    let activeSlide = slider.el.querySelectorAll('.swiper-slide')[slider.activeIndex];
    if(activeSlide.querySelector('video') !== null) activeSlide.querySelector('video').play();
    else if(activeSlide.querySelector('iframe.yt-player') !== null) playYoutubeVideo(activeSlide.querySelector('iframe.yt-player'));
    else if(activeSlide.querySelector('iframe.vi-player') !== null) playVimeoVideo(activeSlide.querySelector('iframe.vi-player'));
}

export function selectInputProvinces(country, fieldProvinces, optionsProvincesSpain) {
    let fieldProvincesContainer = fieldProvinces.parentNode,
        actualValue = fieldProvinces.value;
    if (country === 'es') {
        if (fieldProvinces.tagName.toLowerCase() === 'input') {
            let selectHtml = `<select id="${fieldProvinces.id}" name="${fieldProvinces.getAttribute('name')}" class="form-select" data-validation="required" data-validation-event="blur">
                                        ${optionsProvincesSpain}
                                    </select>`;
            fieldProvinces.outerHTML = selectHtml;
        }
    } else {
        if (fieldProvinces.tagName.toLowerCase() === 'select') {
            //Si es un campo input hay que cambiarlo por un select
            let inputHtml = `<input id="${fieldProvinces.id}" name="${fieldProvinces.getAttribute('name')}" class="form-control" data-validation="required" data-validation-event="blur" placeholder="${document.querySelector('.placeholder-province').innerHTML}"/>`;
            fieldProvinces.outerHTML = inputHtml;
        }
    }
}

export function showHideBillingAddress(check, div) {
    if(!check.checked) {
        div.classList.remove('d-none');
        div.classList.add('d-flex');
        document.getElementById('nombre_facturacion').setAttribute('data-validation','required');
        document.getElementById('nombre_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('apellido_facturacion').setAttribute('data-validation','required');
        document.getElementById('apellido_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('direccion_facturacion').setAttribute('data-validation','required');
        document.getElementById('direccion_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('pais_facturacion').setAttribute('data-validation','required');
        document.getElementById('pais_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('provincia_facturacion').setAttribute('data-validation','required');
        document.getElementById('provincia_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('ciudad_facturacion').setAttribute('data-validation','required');
        document.getElementById('ciudad_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('cp_facturacion').setAttribute('data-validation','required');
        document.getElementById('cp_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('telefono_facturacion').setAttribute('data-validation','required');
        document.getElementById('telefono_facturacion').setAttribute('data-validation-event','blur');
        document.getElementById('dni_facturacion').setAttribute('data-validation','required');
        document.getElementById('dni_facturacion').setAttribute('data-validation-event','blur');
    } else {
        div.classList.remove('d-flex');
        div.classList.add('d-none');
        document.getElementById('nombre_facturacion').removeAttribute('data-validation');
        document.getElementById('nombre_facturacion').removeAttribute('data-validation-event');
        document.getElementById('apellido_facturacion').removeAttribute('data-validation');
        document.getElementById('apellido_facturacion').removeAttribute('data-validation-event');
        document.getElementById('direccion_facturacion').removeAttribute('data-validation');
        document.getElementById('direccion_facturacion').removeAttribute('data-validation-event');
        document.getElementById('pais_facturacion').removeAttribute('data-validation');
        document.getElementById('pais_facturacion').removeAttribute('data-validation-event');
        document.getElementById('provincia_facturacion').removeAttribute('data-validation');
        document.getElementById('provincia_facturacion').removeAttribute('data-validation-event');
        document.getElementById('ciudad_facturacion').removeAttribute('data-validation');
        document.getElementById('ciudad_facturacion').removeAttribute('data-validation-event');
        document.getElementById('cp_facturacion').removeAttribute('data-validation');
        document.getElementById('cp_facturacion').removeAttribute('data-validation-event');
        document.getElementById('telefono_facturacion').removeAttribute('data-validation');
        document.getElementById('telefono_facturacion').removeAttribute('data-validation-event');
        document.getElementById('dni_facturacion').removeAttribute('data-validation');
        document.getElementById('dni_facturacion').removeAttribute('data-validation-event');
    }
}

export function hideShowBtnCetelem(country, btnPaymentCetelem, cetelemCalculator) {
    if (country === 'es') {
        btnPaymentCetelem.classList.remove('d-none');
        if (cetelemCalculator !== null) cetelemCalculator.classList.remove('d-none');
    } else {
        btnPaymentCetelem.classList.add('d-none');
        if (cetelemCalculator !== null) cetelemCalculator.classList.add('d-none');
    }
}

export function hideShownSusbscriptionButton(target) {
    let inputRadioPrice =  target.querySelector('.priceRadio'),
        inputRadioOption =  target.querySelector('.optionRadio'),
        isChecked = inputRadioPrice.checked && inputRadioOption.checked;

    if (isChecked) {
        if(inputRadioPrice.classList.contains('priceSubscription')) {
            document.querySelectorAll('.show_if_suscription').forEach((element) => {
                element.style.removeProperty('display');
            })
            document.querySelectorAll('.show_if_not_suscription').forEach((element) => {
                element.style = 'display: none !important;'
            })
        } else {
            document.querySelectorAll('.show_if_not_suscription').forEach((element) => {
                element.style.removeProperty('display');
            })
            document.querySelectorAll('.show_if_suscription').forEach((element) => {
                element.style = 'display: none !important;'
            })
        }
    }
}